import { __decorate } from "tslib";
import { Vue, Component } from "vue-property-decorator";
import vCLickOutside from "v-click-outside";
let LoaderApp = class LoaderApp extends Vue {
};
LoaderApp = __decorate([
    Component({
        directives: {
            clickOutside: vCLickOutside.directive,
        },
        components: {},
    })
], LoaderApp);
export default LoaderApp;
